<template>
    <div class="admin-header">
        <div class="header-content">
            <div class="header-left">
                <h1 class="page-title">{{ title }}</h1>
                <span class="page-subtitle">{{ subtitle }}</span>
            </div>
            <div class="header-right">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdminPageHeader',
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.admin-header {
    background: white;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 0;
}

.admin-header .header-content {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 16px 24px;
    width: 100%;
    box-sizing: border-box;
}

.admin-header .header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.admin-header .header-right {
    display: flex !important;
    gap: 12px;
    flex-shrink: 0;
    margin-left: auto;
}

.page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #262626;
}

.page-subtitle {
    color: #8c8c8c;
    font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .admin-header .header-content {
        padding: 12px 16px;
    }

    .page-title {
        font-size: 18px;
    }

    .page-subtitle {
        font-size: 13px;
    }
}
</style>